module.exports = __webpack_public_path__ + "img/gcdp1_1.381fb18c.jpg";